import React from 'react';
import { LogoCarouselProps } from './types';
import clsx from 'clsx';
import { BaseImage } from '../baseImage/BaseImage';

export const LogoCarousel: React.FC<LogoCarouselProps> = ({
  title,
  items,
  className = '',
  sectionBackgroundColor,
  sectionId,
}) => {
  return (
    <div
      data-component-id="C027"
      id={sectionId}
      className={clsx(
        `sm:px- relative mx-auto flex w-full flex-col items-center gap-14 px-4 py-8 bg-${sectionBackgroundColor}`,
        className,
      )}
    >
      {title && (
        <h3 className="text-xs font-semibold uppercase text-brand-700 md:text-sm">
          {title}
        </h3>
      )}
      <div
        className={`absolute left-0 top-0 z-10 h-full w-1/2 bg-gradient-to-r from-bg-${sectionBackgroundColor} to-transparent`}
      ></div>
      <div
        className={`absolute right-0 top-0 z-10 h-full w-1/2 bg-gradient-to-l from-bg-${sectionBackgroundColor} to-transparent`}
      ></div>

      <div
        className="ticker-wrapper relative flex w-full justify-center overflow-x-hidden"
        aria-label="Text Ticker"
      >
        {['animate-ticker', 'animate-ticker-clone absolute'].map(
          (animationClass, index) => (
            <div
              key={index}
              className={clsx(
                'ticker-content flex items-center gap-4 text-center',
                animationClass,
              )}
            >
              {items?.map((item, idx) => (
                <div
                  key={idx}
                  className="flex h-auto max-w-80 flex-shrink-0 items-center px-10 text-base font-normal text-brand-700 md:text-lg"
                >
                  <BaseImage image={item.image} />
                </div>
              ))}
            </div>
          ),
        )}
      </div>
    </div>
  );
};
